export class QuotationResponseModel {
    billableAmount: number;
    gst: number;
    partnerCommissionTotal: number;
    quotationCurrencyResponses: QuotationCurrencyResponsesModel[] = new Array<QuotationCurrencyResponsesModel>();
    totalCharges: number;
    quotationSnapshotId: string;
    totalBillableAmount: number;
    rateExpiryTime: number;
}
export class QuotationCurrencyResponsesModel {
    beneficiaryCharges: number;
    convenienceFees: number;
    currencyAmount: number;
    currencyCode: string;
    inrEquivalentAmount: number;
    partnerCommissionTotal: number;
    product: string;
    rate: number;
    transactionFees: number;
    partnerCommission = new PartnerCommission();
    quotationCurrencyResponses: QuotationCurrencyResponsesModel[] = new Array<QuotationCurrencyResponsesModel>();

}
export class PartnerCommission {
    commission: string;
    serviceChargesShare: string;

}



// WEBPACK FOOTER //
// ./src/app/_models/quotation/QuotationResponseModel.ts